<div class="card" style="position: relative;">
    <span class="page-title"><i class="bi bi-briefcase page-title-icon"></i>Comprehensive Cover Quotations</span>
    <p-toast></p-toast>
    <div class="search-partners-header">
        <!-- <p-dropdown placeholder="Policy Status" [options]="policyStatusOptions" [(ngModel)]="selectedStatusOption"
            optionLabel="label" optionValue="value" class="status-filter-dropdown" /> -->

        <p-dropdown placeholder="Policy Status"  (onChange)="onStatusChanged($event)" [options]="policyStatusOptions" class="status-filter-dropdown"
            optionValue="value" />
    </div>
    <hr />
    <p-dialog [(visible)]="visible" [modal]="true" [closable]="false"
        [style]="{width:  (screenWidth<900)? '65vw' :'35vw'}">
        <app-loading [message]="loadingMessage"></app-loading>
    </p-dialog>
    <ng-container *ngIf="screenWidth > 700; else partnersList">
        <p-table [value]="quotations()" styleClass="p-datatable-striped" selectionMode="single"
            [(selection)]="selectedpartner" [paginator]="true" [rows]="10" responsiveLayout="scroll">
            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="name">Date Created<p-sortIcon field="name"></p-sortIcon></th>
                    <th pSortableColumn="price">Customer Name</th>
                    <th pSortableColumn="price">Customer Surname</th>
                    <th pSortableColumn="price">Contact Mobile Number</th>
                    <th pSortableColumn="price">VRN</th>
                    <th pSortableColumn="price">Policy Type</th>
                    <th pSortableColumn="price">Cover Total</th>
                    <th pSortableColumn="price">Status</th>
                    <th pSortableColumn="price">Actions</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-quote>
                <tr [pSelectableRow]="quote">
                    <td style="width: 25%; min-width: 7rem;">{{quote['motorInsurancePolicy']['dateCreated'] |
                        date:'medium'}}</td>
                    <td style="width: 25%; min-width: 7rem;">{{quote['motorInsurancePolicy']['client']['firstName'] }}
                    </td>
                    <td style="width: 25%; min-width: 7rem;">{{quote['motorInsurancePolicy']['client']['lastName'] }}
                    </td>
                    <td style="width: 25%; min-width: 7rem;">{{quote['motorInsurancePolicy']['client']['mobileNumber']
                        }}</td>
                    <td style="width: 25%; min-width: 7rem;">{{quote['motorInsurancePolicy']['vehicle']['vrn'] }}</td>
                    <td style="width: 25%; min-width: 7rem;">{{quote['motorInsurancePolicy']['insuranceType'] }}</td>
                    <td style="width: 25%; min-width: 7rem;">{{quote['motorInsurancePolicy']['totalBaseAmount'] |
                        currency}}</td>
                    <td style="width: 25%; min-width: 7rem;">{{quote['motorInsurancePolicy']['status'] }}</td>
                    <td style="width: 25%; min-width: 7rem; text-align: center;">
                        <div class="partner-actions">
                            <p-button (onClick)="viewQuote(quote['motorInsurancePolicy']['id'])" icon="pi pi-eye" pTooltip="View quote"></p-button>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </ng-container>
    <ng-template #partnersList>
        <p-orderList [value]="quotations()" selectionMode="single" filterBy="name"
            filterPlaceholder="Filter by partner name" [listStyle]="{ 'max-height': '60vh' }">
            <ng-template let-partner pTemplate="item">
                <div class="row-item" (click)="handleListItemClick($event, partner)">
                    <span>{{partner['name']}}</span>
                    <span>{{partner['contactPerson']['firstName']}}</span>
                    <span>{{partner['contactPerson']['mobileNumber']}}</span>
                    <span class="status active-partner" *ngIf="partner['active']">ACTIVE</span>
                    <span class="status inactive-partner" *ngIf="!partner['active']">INACTIVE</span>
                </div>
            </ng-template>
        </p-orderList>
    </ng-template>
    <ng-template #noPartnersBlock>
        <app-no-table-content [message]="'No records found'"></app-no-table-content>
    </ng-template>
</div>